import { render, staticRenderFns } from "./PatientSchedule.vue?vue&type=template&id=0f803508&scoped=true"
import script from "./PatientSchedule.vue?vue&type=script&lang=js"
export * from "./PatientSchedule.vue?vue&type=script&lang=js"
import style0 from "./PatientSchedule.scss?vue&type=style&index=0&id=0f803508&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f803508",
  null
  
)

export default component.exports